import styled, { css } from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import { shape } from "prop-types";

import contactProps from "src/shared/utilities/graphql/contactProps";

import getAvatarSrc from "../../utilities/getAvatarSrc";

export const Avatar = styled.div`
  background: grey url('${({ contact }) => getAvatarSrc(contact)}');
  background-position: center;
  background-size: cover;
  border-radius: 100%;
  height: 70px;
  margin-right: 20px;
  min-width: 70px;
  position: relative;
  width: 70px;
  
  ${({ contact }) =>
    contact?.is_pro &&
    css`
      &::after {
        background: ${colors.primary};
        bottom: 0;
        color: white;
        content: "PRO";
        display: block;
        font-size: 12px;
        font-weight: bold;
        height: 16px;
        left: 50%;
        line-height: 16px;
        padding: 0;
        position: absolute;
        text-align: center;
        transform: translate(-50%, 50%);
        width: 32px;
      }
    `}
`;

Avatar.propTypes = {
  contact: shape(contactProps)
};

Avatar.defaultProps = {
  contact: null
};
